<template>
  <footer class="caixa-flutuante-inferior" :style="'height:' + altura + 'px;' + estilo">
    <slot></slot>
  </footer>
</template>

<script>
export default {
  name: "CaixaFlutuanteInferior",
  props: ["altura", "estilo"]
};
</script>

<style scoped>
.caixa-flutuante-inferior {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  width: 100%;
  padding: 0.5rem 1rem;
  box-shadow: rgba(48, 51, 60, 0.25) 0px -1px 2px;
  margin: 0px auto;
  z-index: 999;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/CaixaFlutuanteInferior.vue